import React, { useState, useEffect } from "react";
import SavedQuestion from "./SavedQuestion";
import {
  TextField,
  Button,
  Box,
  IconButton,
  Typography
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import PracticePageLayout, {
  inputSx,
  primaryButtonSx
} from "./PracticePageLayout";

const EXAMPLE_QUESTIONS = [
  "Walk me through a project you led end to end.",
  "Tell me about a time you disagreed with a teammate.",
  "Why this company, specifically?",
  "What's a decision you'd make differently today?",
  "How do you measure the success of your work?"
];

const QuestionList = () => {
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState("");
  const [conversationText, setConversationText] = useState([]);
  const [blobURLs, setBlobURLs] = useState([]);
  const [audioKeys, setAudioKeys] = useState([]);
  const [responseTexts, setResponseTexts] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);

  const handleBlobURLChange = (index, blobURL) => {
    const newBlobURLs = [...blobURLs];
    newBlobURLs[index] = blobURL;
    setBlobURLs(newBlobURLs);
  };

  const handleAudioKeyChange = (index, audioKey) => {
    const newAudioKeys = [...audioKeys];
    newAudioKeys[index] = audioKey;
    setAudioKeys(newAudioKeys);
  };
  const handleConversationTextChange = newItems => {
    setConversationText([...conversationText, ...newItems]);
    console.log([...conversationText, ...newItems]);
  };
  const handleResponseTextChange = (index, responseText) => {
    const newResponseTexts = [...responseTexts];
    newResponseTexts[index] = responseText;
    setResponseTexts(newResponseTexts);
  };

  const handleFeedbackChange = (index, feedback) => {
    const newFeedbacks = [...feedbacks];
    newFeedbacks[index] = feedback;
    setFeedbacks(newFeedbacks);
  };
  const removeQuestion = questionID => {
    setQuestions(questions.filter(question => question.id !== questionID));
  };
  useEffect(() => {
    /* fetch users saved questions
    const fecthUserData = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setUser(user);
        //get the user associated with the user id, so when create question all need is user id
        const { data } = await API.graphql(
          graphqlOperation(getUser, {
            id: user.username
          })
        );
        console.log("user effect ");
        setQuestions(data.getUser.questions.items);
        setName(user.attributes.name);
      } catch (error) {
        console.log(error);
        setUser(null);
      }
    };
    fecthUserData();
    */
  }, []);

  const handleQuestionChange = event => {
    setNewQuestion(event.target.value);
  };

  const handleQuestionSubmit = () => {
    setQuestions([...questions, newQuestion]);
    setNewQuestion("");
  };

  const handleQuestionDelete = indexToDelete => {
    setQuestions(questions.filter((_, index) => index !== indexToDelete));
    const newBlobURLs = [...blobURLs];
    newBlobURLs.splice(indexToDelete, 1);
    setBlobURLs(newBlobURLs);
    const newAudioKeys = [...audioKeys];
    newAudioKeys.splice(indexToDelete, 1);
    setAudioKeys(newAudioKeys);
    const newResponseTexts = [...responseTexts];
    newResponseTexts.splice(indexToDelete, 1);
    setResponseTexts(newResponseTexts);
    const newFeedbacks = [...feedbacks];
    newFeedbacks.splice(indexToDelete, 1);
    setFeedbacks(newFeedbacks);
    const newConversation = [...conversationText];
    newConversation.splice(indexToDelete, 1);
    setConversationText(newConversation);
  };

  const questionCards = questions.map((question, index) => {
    return (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 1,
          mt: 2
        }}
      >
        <Box sx={{ flex: 1 }}>
          <SavedQuestion
            question={question}
            questionID={index}
            removeQuestion={() => removeQuestion(index)}
            index={index}
            conversation={conversationText}
            blobURL={blobURLs[index]}
            audioKey={audioKeys[index]}
            responseText={responseTexts[index]}
            feedback={feedbacks[index]}
            onBlobURLChange={blobURL => handleBlobURLChange(index, blobURL)}
            onAudioKeyChange={audioKey => handleAudioKeyChange(index, audioKey)}
            onResponseTextChange={responseText =>
              handleResponseTextChange(index, responseText)
            }
            onConversationTextChange={handleConversationTextChange}
            onFeedbackChange={feedback => handleFeedbackChange(index, feedback)}
            unsaved={1}
          />
        </Box>
        <IconButton
          edge="end"
          aria-label="delete"
          onClick={() => handleQuestionDelete(index)}
          sx={{ mt: 1 }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    );
  });

  const handleExampleAdd = text => {
    setQuestions(prev => [...prev, text]);
  };

  const aside =
    questions.length === 0 ? (
      <Box>
        <Typography
          sx={{
            fontFamily:
              "'JetBrains Mono', 'Söhne Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
            fontSize: "0.7rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "rgba(15, 17, 33, 0.55)",
            mb: 2
          }}
        >
          Need a starting point — tap to add
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1
          }}
        >
          {EXAMPLE_QUESTIONS.map(text => (
            <Box
              key={text}
              component="button"
              onClick={() => handleExampleAdd(text)}
              sx={{
                appearance: "none",
                cursor: "pointer",
                textAlign: "left",
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                py: 1,
                px: 1.5,
                backgroundColor: "#ffffff",
                border: "1px solid rgba(15, 17, 33, 0.1)",
                borderRadius: "999px",
                color: "rgba(15, 17, 33, 0.78)",
                fontFamily: "'sohne-var', 'Helvetica Neue', 'Arial', sans-serif",
                fontSize: "0.86rem",
                lineHeight: 1.2,
                transition:
                  "border-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease, color 0.18s ease",
                boxShadow: "0 1px 2px rgba(15, 17, 33, 0.04)",
                "&:hover": {
                  borderColor: "rgba(56, 84, 232, 0.45)",
                  color: "#0f1121",
                  transform: "translateY(-1px)",
                  boxShadow: "0 8px 18px -12px rgba(56, 84, 232, 0.55)"
                },
                "&:active": {
                  transform: "translateY(0) scale(0.98)"
                }
              }}
            >
              <AddIcon
                sx={{ fontSize: 14, color: "rgba(56, 84, 232, 0.85)" }}
              />
              {text}
            </Box>
          ))}
        </Box>
      </Box>
    ) : null;

  return (
    <PracticePageLayout
      icon={<FormatListBulletedOutlinedIcon />}
      kicker="Bring your own"
      title="Drill the questions you know are coming."
      subtitle="Import your own list, then walk through each one with audio recording and instant, written feedback."
      aside={aside}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "flex-start" },
          gap: 1.5
        }}
      >
        <TextField
          sx={{ ...inputSx, flex: 1, mb: 0 }}
          label="Type a question"
          value={newQuestion}
          onChange={handleQuestionChange}
          variant="outlined"
          fullWidth
        />
        <Button
          sx={{ ...primaryButtonSx, whiteSpace: "nowrap", py: 1.55 }}
          variant="contained"
          onClick={handleQuestionSubmit}
          disabled={!newQuestion}
        >
          Add question
        </Button>
      </Box>
      {questionCards.length > 0 && <Box sx={{ mt: 2 }}>{questionCards}</Box>}
    </PracticePageLayout>
  );
};

export default QuestionList;
